import React from 'react';
import cn from '../../../../../../utils/cn';

function ToggleMenu({ item, handleToggle, loading }) {
    const isPermitted = item?.status;
    return (
        <div className="w-auto">
            <button
                type="button"
                className={cn('w-[38px] h-[18px] rounded-[48px] p-[3px] bg-gray-400', {
                    'bg-secondary': isPermitted,
                    'pointer-events-none grayscale': loading
                })}
                onClick={() => handleToggle(item)}
            >
                <span
                    className={`w-[14px] h-full block bg-white rounded-[48px] ${
                        isPermitted ? 'float-end' : ''
                    }`}
                />
            </button>
        </div>
    );
}

function TableRow({ item, handleToggle, pageLoading, loading }) {
    return (
        <div
            className={cn(
                `table-visible-data overflow-hidden text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight h-auto`,
                {
                    'placeholder-mode': pageLoading || item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-8 items-center justify-between text-primary font-medium leading-normal">
                <div className="w-full">
                    <span className="text-base font-bold">{item?.title}</span>
                    <span className="line-clamp-1 text-xs sm:text-sm">{item?.description}</span>
                </div>

                <ToggleMenu item={item} handleToggle={handleToggle} loading={loading} />
            </div>
        </div>
    );
}

function TableMobile({ permissions, handleToggle, pageLoading, loading }) {
    return (
        <div className="customer_page_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {permissions && permissions?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    permissions?.map((item) => (
                        <TableRow
                            key={item.id}
                            item={item}
                            handleToggle={handleToggle}
                            pageLoading={pageLoading}
                            loading={loading}
                        />
                    ))
                )}
            </div>
        </div>
    );
}

export default TableMobile;
